export default __webpack_public_path__ + "static/media/signin-persona-ext-travelers.04b4e31e.svg";